export default "__VITE_ASSET__e4e5fed7__"